import type { Cell } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import * as React from 'react';

import styles from './styles.module.scss';

type Props<T> = {
	cell: Cell<T, unknown>;
	className?: string;
	name: string;
	onCellClick?: (cellName: string) => void;
	style?: React.CSSProperties;
};

function BaseCell<T,>(props: React.PropsWithChildren<Props<T>>) {
	const { cell, onCellClick, name, className = '', style } = props;

	const handleOnCellClick = React.useCallback(() => {
		if (!!onCellClick) {
			onCellClick(name);
		}
	}, [name, onCellClick]);

	return (
		<span
			className={`${styles['simple-table__cell']} ${className}`}
			onClick={handleOnCellClick}
			style={style}
		>
			{flexRender(cell.column.columnDef.cell, cell.getContext())}
		</span>
	);
}

export default React.memo(BaseCell) as typeof BaseCell;
